const mutations = {
  onGet (state, payload) {
    payload.event.context.inspections = payload.response.data.data.data
    if (payload.event.context.options) {
      payload.event.context.options.itemsPerPage = parseInt(payload.response.data.data.per_page)
      payload.event.context.options.page = payload.response.data.data.current_page
      payload.event.context.options.total = payload.response.data.data.total
    }
    payload.event.context.loadTable = false
  },
  onGetOperatorValidate(state, payload) {
    payload.event.context.operatorValidate = payload.response.data.data
  },
  onGetById (state, payload) {
    payload.event.context.editedItem = payload.response.data.data
    payload.event.context.editedItem.sections.forEach(section => {
      section.questions.forEach(question => {
        question.answer = question.answer === null ? 'N/A' : question.answer
      })
    })
    payload.event.context.loadItem = false
  },
onGetPdf (state, { event, response }) {
  const ctx = event.context;
  ctx.loadReport = false;
  if (!response.data) return;
  const header = response.headers['content-disposition'] || '';
  const matchUtf8 = header.match(/filename\*=utf-8''([^;]+)/i);
  const matchNormal = header.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);

  const fileName = matchUtf8 ? decodeURIComponent(matchUtf8[1])
                 : matchNormal ? matchNormal[1].replace(/['"]/g, '')
                 : `${ctx.$t('general.inspection')} #${ctx.editedItem.consecutive_number} ${ctx.editedItem.name}.pdf`;
  ctx.forceFileDownload(response.data, fileName);
},
  onDelete (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.get()
    payload.event.context.close()
    payload.event.context.loading = false
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
    payload.event.context.loadingReport = false
    payload.event.context.isChartLoading = false
    payload.event.context.DamageLoading = false
    payload.event.context.SitesDamageLoading = false
    payload.event.context.loadTable = false
  },
  onGetReports (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, 'reports.zip')
    payload.event.context.loadingReport = false
  },
  onGetDamagePercentage(state, payload) {
    if (payload.response && payload.response.data && payload.response.data.data) {

      const { accepted = 0, low = 0, medium = 0, high = 0 } = payload.response.data.data.damageLevels || {}

      if (accepted === 0 && low === 0 && medium === 0 && high === 0) {
        payload.event.context.damagePieSeries = ['1']
      } else {
        payload.event.context.damagePieSeries = [accepted, low, medium, high];
        payload.event.context.damagePieChartOptions.colors = ['#28a745', '#17a2b8', '#ffc107', '#dc3545'];
        payload.event.context.damagePieChartOptions.labels = [payload.event.context.$t('general.withoutDamage'), payload.event.context.$t('general.low'), payload.event.context.$t('general.medium'), payload.event.context.$t('general.high')];
        payload.event.context.damagePieChartOptions.dataLabels.formatter = function (val, opts) {
          const realValue = opts.w.config.series[opts.seriesIndex];
          return realValue;
        }
        payload.event.context.damagePieChartOptions.chart.toolbar.export = {
          csv: { 
                filename: payload.event.context.$t('dashboard.damageInspectionsReport', {starDate: payload.event.context.damageFilters.start_date, endDate: payload.event.context.damageFilters.end_date}), 
                columnDelimiter: ',',
                headerCategory: payload.event.context.$t('monitoring.levelDamage'),
                headerValue: payload.event.context.$t('general.quantity')
              },
              svg: { 
                filename: payload.event.context.$t('dashboard.damageInspectionsReport', {starDate: payload.event.context.damageFilters.start_date, endDate: payload.event.context.damageFilters.end_date}), 
              },
              png: { 
                filename: payload.event.context.$t('dashboard.damageInspectionsReport', {starDate: payload.event.context.damageFilters.start_date, endDate: payload.event.context.damageFilters.end_date}),
              },
        }

        payload.event.context.damagePieChartOptions.plotOptions = {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  label: payload.event.context.$t('inspections.inspectedPoints'),
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce(function (a, b) {
                      return a + b;
                    }, 0);
                  }
                }
              }
            }
          }
        }
      }
    } else {
      payload.event.context.damagePieSeries = [1]
    }
    payload.event.context.DamageLoading = false;
  },
  onGetTopSites(state, payload) {
      if (payload.response && payload.response.data && payload.response.data.data) {
        payload.event.context.topSites = payload.response.data.data;
      } else {
        payload.event.context.topSites = [];
      }

      payload.event.context.SitesDamageLoading = false;
    },
  onGetInspectionClassifications(state, data) {
    state.inspectionClassifications = data || [];
  },
  onGetInspectionLineData(state, data) {
    const dates = [...new Set(data.flat().map(item => item.date))]
                  .sort((a, b) => new Date(a) - new Date(b));

    const result = data.map(site => ({
      name: site[0].site_name,
      data: site
    }))

    state.inspectionLineSeries = result.map(site => ({
      name: site.name,
      data: dates.map(item => ({
          x: new Date(item + 'T12:00:00').getTime(),
          y: (site.data.find(inspections_count => inspections_count.date === item) || {}).inspections_count || 0
        }))
      })
    )

    state.isChartLoading = false;
  },
  onGetInspectionIndicators(state, data) {
    state.inspectionIndicators = {
      units_total: data.units_total || 0,
      soft: data.soft || 0,
      moderate: data.moderate || 0,
      hard: data.hard || 0,
      units_hard: data.units_hard || 0,
      inspections_total: data.inspections_total || 0,
      units_rejected: data.units_rejected || 0
    };
  },
  onGetInspectionPointsDamaged(state, payload) {
    const data = payload.response.data.data.data || [];
    const context = payload.event.context;
    const categories = data.map(item => item.name);
    context.stackedBarSeries = [
      { name: context.$t('general.low'), data: data.map(item => parseInt(item.soft || 0)) },
      { name: context.$t('general.medium'), data: data.map(item => parseInt(item.moderate || 0)) },
      { name: context.$t('general.high'), data: data.map(item => parseInt(item.hard || 0)) }
    ];
    if (context.$refs.stackedBarChart) {
      context.$refs.stackedBarChart.updateOptions({
        xaxis: { categories: categories }
      });
    } else {
      context.stackedBarOptions = {
        ...context.stackedBarOptions,
        xaxis: { ...context.stackedBarOptions.xaxis, categories: categories }
      };
    }
    context.InspectionPointsLoading = false;
  },
  onGetOperatorCountDamaged(state, payload) {
    const context = payload.event.context;
    
    if (payload.response && payload.response.data && payload.response.data.data && payload.response.data.data.data) {
      
      const operatorsData = payload.response.data.data.data;
      
      context.topOperators = operatorsData.map(op => ({
        name: `${op.name} ${op.last_name}`,
        total: parseInt(op.total || 0),
        soft: parseInt(op.soft || 0),      
        moderate: parseInt(op.moderate || 0),
        hard: parseInt(op.hard || 0)
      }));

    } else {
      context.topOperators = [];
    }
    context.OperatorsDamageLoading = false;
  },
  onGetDamageFrequencyByUnit(state, payload) {
    const context = payload.event.context;
  
    const responseData = payload.response.data.data.data || [];
    
    let filteredData = responseData.filter(unit => parseInt(unit.count_inspection || 0) >= 10);

    let processedData = filteredData.map(unit => {
      const inspections = parseInt(unit.count_inspection || 0);
      const inspectionsWithDamage = parseInt(unit.count_inspection_damage || 0);
      
      const soft = parseInt(unit.count_damange_soft || 0);
      const moderate = parseInt(unit.count_damange_moderate || 0);
      const hard = parseInt(unit.count_damange_hard || 0);
      const totalDamages = soft + moderate + hard;

      const frequency = inspections > 0 ? ((inspectionsWithDamage / inspections) * 100) : 0;
      
      const damagesPerDay = unit.damage_per_day ? parseFloat(unit.damage_per_day).toFixed(1) : '0.0';

      const plate = unit.plates && unit.plates.length > 0 ? unit.plates[0].plate_number : 'N/A';

      return {
        unitNumber: unit.unit_number,
        plate: plate,
        frequency: frequency,
        soft: soft,
        moderate: moderate,
        hard: hard,
        totalDamages: totalDamages,
        damagesPerDay: damagesPerDay
      };
    });

    processedData.sort((a, b) => b.totalDamages - a.totalDamages);
    processedData = processedData.slice(0, 10);

    const categories = processedData.map(item => item.unitNumber);
    
    context.damageFrequencySeries = [
      { name: context.$t('inspections.slight'), data: processedData.map(item => item.soft) },
      { name: context.$t('general.medium'), data: processedData.map(item => item.moderate) },
      { name: context.$t('general.high'), data: processedData.map(item => item.hard) }
    ];

    context.damageFrequencyTooltipData = processedData;

    if (context.$refs.damageFrequencyChart) {
      context.$refs.damageFrequencyChart.updateOptions({
        xaxis: { categories: categories }
      });
    } else {
      context.damageFrequencyOptions = {
        ...context.damageFrequencyOptions,
        xaxis: { 
          ...(context.damageFrequencyOptions ? context.damageFrequencyOptions.xaxis : {}), 
          categories: categories 
        }
      };
    }

    context.DamageFrequencyLoading = false;
  },
}

export default mutations